/**
 * Escapa un campo para CSV (RFC 4180).
 * Entre comillas si Excel podría interpretar mal el valor (fórmulas con =,+,-,@ al inicio;
 * teléfonos con +; cadenas solo numéricas largas que Excel convertiría a número).
 */
export function escapeCsvField(value: unknown): string {
  const s = value == null ? '' : String(value);
  const trimmed = s.trim();
  // Guion al inicio de la clase para no formar rango con + y @
  const excelFormulaLike = /^[-=+@\t]/.test(s);
  const longDigitsOnly = /^\d{10,}$/.test(trimmed);
  const mustQuote = /[\r\n",]/.test(s) || excelFormulaLike || longDigitsOnly || s.includes('@');
  if (mustQuote) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** Primera fila = encabezados; siguientes = valores por fila. BOM UTF-8 para Excel. */
export function buildCsv(headers: string[], rows: string[][]): string {
  const lines = [
    headers.map(escapeCsvField).join(','),
    ...rows.map((r) => r.map(escapeCsvField).join(',')),
  ];
  return `\uFEFF${lines.join('\r\n')}`;
}

export function downloadCsvFile(filename: string, csvContent: string): void {
  const name = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
